import { gtcAddToCart, gtcChangeQuantity } from 'gtcUtils';

class GtcPreorder {
    constructor() {
        this.handlePreorderAction = this.handlePreorderAction.bind(this);

        this.initialized = false;
        this.init();
    }

    init() {
        if (this.initialized) return;

        this.setupEventListeners();
        this.initialized = true;

        this.handlePreorderAction();
    }

    setupEventListeners() {
        document.addEventListener('on:cart:add', this.handlePreorderAction);
        document.addEventListener('on:variant:change', this.handlePreorderAction);
        document.addEventListener('on:line-item:change', this.handlePreorderAction);
        document.addEventListener('on:gtc-preorder:update', this.handlePreorderAction);
    }

    async handlePreorderAction() {
        const { preorder_freight_item_id, preorder_freight_item_status } = await this.fetchPreorderData();
        switch (preorder_freight_item_status) {
            case 'add':
                gtcAddToCart({ variantId: preorder_freight_item_id, properties: { _preorderShipping: true } });
                break;
            case 'reduce_to_one':
                gtcChangeQuantity({ variantId: preorder_freight_item_id, quantity: 1 });
                break;
            case 'remove':
                gtcChangeQuantity({ variantId: preorder_freight_item_id, quantity: 0 });
                break;
        }
    }

    async fetchPreorderData() {
        try {

            const response = await fetch(Shopify.routes.root + 'cart?view=preorder-data')
            if (!response.ok) throw new Error('Failed to fetch cart data');
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('Error fetching cart data:', error);
        }
    }




}

// Auto-initialize 
new GtcPreorder()